import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { GenericConfig } from '@signature-it/ngx-generic/config';

@Pipe({
    name: 'pipeReplacer',
    standalone: false
})
export class PipeReplacerPipe implements PipeTransform {

    char: string = GenericConfig.replacePipeWith;
    transform(value: string): any {
        if (this.char) {
            value = String(value).replace(/\|/g, this.char).trim();
        }
        return value;
    }
}

@NgModule({
    declarations: [PipeReplacerPipe],
    exports: [PipeReplacerPipe],
})
export class PipeReplacerPipeModule {}
